<div class="app-modal-dialog" *ngIf="_show">
    <div class="overlay">
    </div>
    <div class="window shadow-lg" [ngClass]="windowClass">
        <div class="app-modal-header">
            <span>{{ title }}</span>
            <a href="javascript:;" (click)="close()" class="app-modal-close"><i class="fa fa-times"></i></a>
        </div>
        <div class="app-modal-content">
            <span *ngIf="message">{{ message }}</span>
            <ul *ngIf="messages && messages.length > 0" class="app-modal-list">
                <li *ngFor="let message of messages">{{ message }}</li>
            </ul>
        </div>
        <div class="app-modal-actions" *ngIf="buttons && buttons.length > 0">
            <button class="btn" *ngFor="let button of buttons" [ngClass]="!button.look ? 'btn-warning' : button.look" (click)="onButtonClick(button)">
                <i class="fa mr-2" [ngClass]="!button.lookIcon ? 'fa-times' : button.lookIcon"></i>{{ button.title }}</button>
        </div>
    </div>
</div>